import React from 'react'
import PropTypes from 'prop-types'
import Interweave from 'interweave'
import { convertMdToHtml } from '..'
import Alert from '../../Alert'
import { ALERT_TYPE } from '../../Alert'
import Section from '../../Section'

const AssessmentBreakdown = ({ report: { reportContent } }) => (
  <Section title="Assessment Breakdown">
    <div>
      {reportContent.summary.goals.breakdown ? (
        <Interweave content={convertMdToHtml.makeHtml(reportContent.summary.goals.breakdown)} />
      ) : (
        <p>
          Quantstamp&#39;s objective was to evaluate the {reportContent.setup.projectName}
          &nbsp;repository for security-related issues, code quality, and adherence to specification
          and best practices.
        </p>
      )}
    </div>
    {reportContent.summary.disclaimer?.text ? (
      <Alert type={ALERT_TYPE.INFO}>
        <b>Disclaimer</b>

        <Interweave content={convertMdToHtml.makeHtml(reportContent.summary.disclaimer.text)} />
      </Alert>
    ) : null}
    {reportContent.breakdownAndAutomatedAnalysis.possibleIssues ? (
      <div>
        <h4>Possible issues we looked for included (but are not limited to):</h4>

        <Interweave
          content={convertMdToHtml.makeHtml(
            reportContent.breakdownAndAutomatedAnalysis.possibleIssues,
          )}
        />
      </div>
    ) : null}
    {reportContent.breakdownAndAutomatedAnalysis.methodology ? (
      <div>
        <h4>Methodology</h4>

        <Interweave
          content={convertMdToHtml.makeHtml(
            reportContent.breakdownAndAutomatedAnalysis.methodology,
          )}
        />
      </div>
    ) : null}
  </Section>
)

AssessmentBreakdown.propTypes = {
  report: PropTypes.object,
}

export default AssessmentBreakdown
